module.exports = __webpack_public_path__ + "img/tree-06-b-trunk.04011f2f.png";